import ability from './ability'

export const canNavigate = to => to.matched.some(route => ability.can(route.meta.action || 'read', route.meta.subject || route.meta.resource || !route.meta.authRequired))

export const _ = undefined
